import app from "../_app";
import axios from "axios";
import { addToCartHandler } from "./addToCart";

const microcart = document.querySelector('.js-microcart');
const microcartUpsellProducts = document.querySelector('.js-microcart-upsell');

export const updateMicrocart = async () => {
    if(microcart) {
        let response = await axios.get(`${Shopify.routes.root}cart.js`);

        if (response.status === 200) {
            let data = response.data;

            if(data.item_count > 0) {
                const microcartProducts = microcart.querySelector('.js-microcart-products');
                microcart.removeAttribute('data-empty');

                microcartProducts.innerHTML = data.items.map((item, index) => {
                    const variantTitle = item.variant_title ? ' - ' + item.variant_title : '';
                    const image = item.image ? `<img src="${item.image.replace('.png', '_x250.png')}" alt="${item.title}" loading="lazy">` : '';
                    return `
                    <a class="microcart__product row align-items-center no-gutters mx-0 mb-2" href="${item.url}">
                        <div class="microcart__product-image img col-auto">
                            ${image}
                        </div>
                        <div class="col ml-2 py-2">
                            <h4 class="microcart__product-heading heading heading--xxs mb-1">
                                ${item.product_title} ${variantTitle}
                            </h4>
                            <p class="text">
                                ${item.quantity}x ${app.currency(item.price, false)}
                            </p>
                        </div>
                    </a>
                  `;
                }).join('').replace(/\n\s+/g, '');

                if (microcartUpsellProducts) {
                    microcartUpsellProducts.classList.remove('d-none');
                }

                const microcartCount = document.querySelector('.js-cart-items-count');
                microcartCount.innerText = data.item_count;
            }
        }
    }
}

const header = document.querySelector('.js-header');
const microcartTriggers = [...document.querySelectorAll('.js-microcart-trigger')];

export const toggleMicrocart = () => {
    if(microcart.hasAttribute('data-active')) {
        microcart.removeAttribute('data-active');
        if(header.hasAttribute('data-microcart-open')) {
            header.removeAttribute('data-microcart-open');
        }
        //app.unlockBody(false);
    } else {
        microcart.setAttribute('data-active', '');
        if(!header.hasAttribute('data-microcart-open')) {
            header.setAttribute('data-microcart-open', '');
        }
        //app.lockBody(false);
    }

    updateMicrocart();
};

if(microcart) {

    microcartTriggers.map(trigger => {
        trigger.addEventListener('click', () => {
            toggleMicrocart();
        })
    });

    const upsellForms = microcart.querySelectorAll('.js-product-upsell-form');
    upsellForms.forEach(form => {
        form.addEventListener('submit', (e) => {
            addToCartHandler(e, 1, false, true);
        });
    });

    updateMicrocart();
}
